/**
 * Author：brand
 * Creation Time：2019-05-11 09:12
 * Email：brandhuang@qq.com
 */
import api from '@/api/index'
import Cookies from 'js-cookie'
import {Message} from 'element-ui'
import {setToken, removeToken, getToken} from '@/utils/auth'
import {initWebsocket} from '@/utils/websocket'
import { resetRouter } from '@/router/router'
import { logout } from '@/api/modules/user'

const INIT_STATE = {
  token:'',
  userInfo: {},
  roles:'', // 客服角色 0：超级管理员；1：管理员；2：普通客服
  agentStatus: 'offline', //客服状态 offline:离线（休息），online：在线
  isAuth: {}, //当前客服所拥有的操作权限
  chosenVoice:{}, //客服消息通知音效
  menu:[], // 当前客服可看到的菜单（管理模式）
  allMenu: [], // 当前客服的所有菜单（客服模式和管理模式）
  ws: null,
  logo:{
    company_small_icon:'https://weiliao.oss.aliyuncs.com/images/1560493280/806fb91e34164a4f9b52e1cd7ad19b0d-logo_mp_s.png',
    // company_icon:'http://weiliao.oss-cn-hangzhou.aliyuncs.com/images/1560493213/6da06185c8644fe59d32af9da463ddd6-logo_mp.png',
	company_icon:'https://weiliao.oss.aliyuncs.com/images/20200421/e7a16b02828147aa996aa9ec680555d5/1587461608650.png'
  },
  updateInfo:{}
}
const state = {
  token:'',
  userInfo: {},
  roles:'', // 客服角色 0：超级管理员；1：管理员；2：普通客服
  agentStatus: 'offline', //客服状态 offline:离线（休息），online：在线
  isAuth: {}, //当前客服所拥有的操作权限
  chosenVoice:{}, //客服消息通知音效
  menu:[], // 当前客服可看到的菜单（管理模式）
  allMenu: [], // 当前客服的所有菜单（客服模式和管理模式）
  ws: null,
  logo:{
    company_small_icon:'https://weiliao.oss.aliyuncs.com/images/1560493280/806fb91e34164a4f9b52e1cd7ad19b0d-logo_mp_s.png',
    // company_icon:'http://weiliao.oss-cn-hangzhou.aliyuncs.com/images/1560493213/6da06185c8644fe59d32af9da463ddd6-logo_mp.png',
	company_icon:'https://weiliao.oss.aliyuncs.com/images/20200421/e7a16b02828147aa996aa9ec680555d5/1587461608650.png'
  },
  updateInfo:{}
}

const mutations = {
  INIT_STATE: (state) => {
    resetRouter()
    Object.assign(state,INIT_STATE)
  },
  USERINFO: (state, data) => {
    state.userInfo = data
  },
  SET_TOKEN:(state,data) => {
    state.token = data
  },
  SET_ROLES:(state, data) =>{
    state.roles = data
  },
  SET_CHOSENVIOCE:(state, data) =>{
    state.chosenVoice = data
  },
  SET_ISAUTH:(state, data) =>{
    state.isAuth = data
  },
  SET_MENU:(state, data) =>{
    state.menu = data
  },
  SET_ALLMENU:(state, data) =>{
    state.allMenu = data
  },
  SET_AGENTSTATUS:(state, data) =>{
    state.agentStatus = data
  },
  CHANAGE_USERINFO:(state,data) => {
    state.userInfo = data
  },
  SET_WS:(state, data) => {
    state.ws = data
  },
  SET_LOGO:(state, data) => {
    state.logo = data
  },
  SET_UPDATEINFO:(state, data) => {
    state.updateInfo = data
  },
}

const actions = {
  /**
   * 登录
   * @param commit
   * @param param
   * @returns {Promise<any>}
   */
  login({ commit },param) {
    return new Promise((resolve, reject) => {
      api.loginAPI(param).then( res => {
        if(res.status == 1){
          Message({
            message: res.msg,
            type: 'success'
          })
          commit("SET_TOKEN",res.token)
          setToken(res.token)
        }else {
          if(res.msg !=  '该客户已到期'){
            Message({
              message: res.msg,
              type: 'error'
            })
          }
        }
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  /**
   * 注册
   * @param commit
   * @param param
   * @returns {Promise<any>}
   */
  register({commit}, param){
    return new Promise((resolve, reject) => {
      api.registerAPI(param).then( res => {
        if(res.status == 1){
          Message({
            message: res.msg,
            type: 'success'
          })
        }else {
          Message({
            message: res.msg,
            type: 'error'
          })
        }
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  /**
   * 用户信息
   * @param commit
   * @param state
   * @returns {Promise<any>}
   */
  userInfo({commit ,state},router){
    return new Promise((resolve, reject) => {
      api.userInfoAPI().then( res => {
        if(res.status == 1){
          let userInfo = res.data.userInfo
          let menu = res.data.menu
          let authMenu = []
          commit('SET_ALLMENU', menu)
          if(userInfo.adminMenu == 1 && userInfo.serviceMenu == 1){
            menu.map( item => {
              authMenu = authMenu.concat(item.children)
            })

          }else if(userInfo.adminMenu == 1 && userInfo.serviceMenu == 0){
            menu.map( item => {
              if(item.path == 'manageMode'){
                authMenu = authMenu.concat(item.children)
              }

            })
          }else if(userInfo.adminMenu == 0 && userInfo.serviceMenu == 1) {
            Cookies.set('agentAuth', 'service')
            window.location.href = process.env.VUE_APP_CHAT_URL
          }else { // 没有添加菜单
            router.push({
              path:'/no-router'
            })
          }
          res.data.menu = authMenu
          commit("USERINFO",res.data.userInfo)
          commit("SET_ROLES",res.data.userInfo.role)
          commit("SET_CHOSENVIOCE",res.data.chosenVoice)
          commit("SET_ISAUTH",res.data.isAuth)
          commit("SET_MENU",authMenu)
          commit("SET_TOKEN",getToken())
          commit("SET_AGENTSTATUS",res.data.agentStatus)
          commit("SET_WS",initWebsocket(res.data.userInfo.csId))
          api.joinGetBtnConfigAPI().then( configRes => {
            if(res.status == 1){
              let configData = configRes.data
              let companylogo = {
                company_small_icon:'https://weiliao.oss.aliyuncs.com/images/1560493280/806fb91e34164a4f9b52e1cd7ad19b0d-logo_mp_s.png',
                // company_icon:'http://weiliao.oss-cn-hangzhou.aliyuncs.com/images/1560493213/6da06185c8644fe59d32af9da463ddd6-logo_mp.png',
				company_icon:'https://weiliao.oss.aliyuncs.com/images/20200421/e7a16b02828147aa996aa9ec680555d5/1587461608650.png'
              }
              if(configData.company_small_icon){
                companylogo.company_small_icon = configData.company_small_icon
              }
              if(configData.company_icon){
                companylogo.company_icon = configData.company_icon
              }

              commit("SET_LOGO",companylogo)
            }
          })
          api.getUpdateTipsAPI().then( res => {
            if(res.status == 1){
              commit("SET_UPDATEINFO",res.data)
            }
          })
          Cookies.set('agentId', res.data.userInfo.csId)
          Cookies.set('agentAvatar', res.data.userInfo.csHeadimg)
          Cookies.set('agentName', res.data.userInfo.csName)
          resolve(res)
        }else {
          Message({
            message: res.msg,
            type: 'error'
          })
          removeToken()
        }

      }).catch( err => {
        reject(err)
      })
    })
  },
  /**
   * 修改用户信息
   * @param commit
   * @param data
   */
  changeUserInfo({commit}, data){
    commit("CHANAGE_USERINFO",data)
  },
  /**
   * 修改用户状态
   * @param commit
   * @param data
   */
  changeUserStatus({commit}, data){
    commit("SET_AGENTSTATUS",data)
  },
  /**
   * 修改来消息声音
   * @param commit
   * @param data
   */
  changeMsgMusic({commit}, data){
    commit("SET_CHOSENVIOCE",data)
  },
  /**
   * 修改LOGO
   * @param commit
   * @param data
   */
  changeCompanyLogo({commit}, data){
    commit("SET_LOGO",data)
  },
  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      if(state.ws){
        state.ws.close() // 关闭websocket
      }
      commit('INIT_STATE')
      removeToken()
      resolve()
    })
  },
  // 重置 state
  initState({commit}){
    return new Promise((resolve, reject) => {
      commit('INIT_STATE')
      resolve()
    })
  },
   // 登出
  logout({ commit ,state}, param) {
    return new Promise( (resolve, reject) => {
      api.logout(param).then( res => {
        if(res.status == 1){
          Message({
            message: res.msg,
            type: 'success'
          })
          state.ws.close() // 关闭websocket
          removeToken()
          commit('INIT_STATE')
          resolve()
        }else {
          Message({
            message: res.msg,
            type: 'error'
          })
        }
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })

  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
